import script from "./Contacto.vue?vue&type=script&setup=true&lang=js"
export * from "./Contacto.vue?vue&type=script&setup=true&lang=js"

import "./Contacto.vue?vue&type=style&index=0&id=f762a5da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f762a5da"]])

export default __exports__